module.exports = __webpack_public_path__ + "static/img/home_kol1@2x.9fe9317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productIntroduction/home_kol1@2x.png
// module id = 5mbi
// module chunks = 0